import adventCalendarRoutes from "@/features/adventCalendar/router";
import arcadeRoutes from "@/features/arcade/routes";
import authRoutes from "@/features/auth/routes";
import blogRoutes from "@/features/blog/routes";
import boutiqueRoutes from "@/features/boutique/routes";
import calendarRoutes from "@/features/calendar/routes";
import cardRoutes from "@/features/card/routes";
import chatRoutes from "@/features/chat/router";
import classifiedAdsRoutes from "@/features/classified-ads/routes";
import customFormsRoutes from "@/features/custom-forms/routes";
import dashboardRoutes from "@/features/dashboard/routes";
import dealsRoutes from "@/features/deals/routes";
import discussionRoutes from "@/features/discussion/routes";
import downloadAppRoutes from "@/features/download-app/routes";
import emailChangeRoutes from "@/features/emailChange/router";
import employeeTransferRoutes from "@/features/employeeTransfer/router";
import fileManagerRoutes from "@/features/fileManager/routes";
import goRoutes from "@/features/go/router";
import helpCenterRoutes from "@/features/helpCenter/router";
import legalRoutes from "@/features/legal/routes";
import notFoundRoutes from "@/features/notFound/routes";
import paymentRefusalsRoutes from "@/features/payment-refusals/routes";
import pollRoutes from "@/features/poll/router";
import postItRoutes from "@/features/post-it/router";
import predictionsRoutes from "@/features/predictions/router";
import purchasePointsRoutes from "@/features/purchasePoints/routes";
import raffleRoutes from "@/features/raffle/router";
import refundsRoutes from "@/features/refunds/routes";
import rentalsRoutes from "@/features/rentals/routes";
import representativesRoutes from "@/features/representatives/routes";
import shopRoutes from "@/features/shop/router";
import sponsorshipRoutes from "@/features/sponsorship/routes";
import subventionsRoutes from "@/features/subventions/routes";
import surveyRoutes from "@/features/survey/router";
import ticketsRoutes from "@/features/tickets/router";
import topUpRoutes from "@/features/topUp/router";
import userProfileRoutes from "@/features/userProfile/routes";
import vouchersRoutes from "@/features/vouchers/routes";
import { redirectRoutes } from "@/router/redirects.config";
import type { RouteConfig } from "@/router/types";

const routes: RouteConfig[] = [
  ...adventCalendarRoutes,
  ...classifiedAdsRoutes,
  ...authRoutes,
  ...dashboardRoutes,
  ...cardRoutes,
  ...blogRoutes,
  ...boutiqueRoutes,
  ...calendarRoutes,
  ...dealsRoutes,
  ...discussionRoutes,
  ...downloadAppRoutes,
  ...fileManagerRoutes,
  ...userProfileRoutes,
  ...refundsRoutes,
  ...paymentRefusalsRoutes,
  ...rentalsRoutes,
  ...customFormsRoutes,
  ...helpCenterRoutes,
  ...ticketsRoutes,
  ...vouchersRoutes,
  ...goRoutes,
  ...topUpRoutes,
  ...pollRoutes,
  ...purchasePointsRoutes,
  ...chatRoutes,
  ...postItRoutes,
  ...representativesRoutes,
  ...shopRoutes,
  ...sponsorshipRoutes,
  ...subventionsRoutes,
  ...surveyRoutes,
  ...raffleRoutes,
  ...predictionsRoutes,
  ...legalRoutes,
  ...employeeTransferRoutes,
  ...emailChangeRoutes,
  ...redirectRoutes,
  ...arcadeRoutes,
  ...notFoundRoutes,
];

export default routes;
